import dayjs from 'dayjs';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';

dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);

export const formatTime = (timestamp?: number) => {
  if (!timestamp) {
    return '';
  }
  const now = dayjs();
  const targetDate = dayjs(timestamp);
  const diffInHours = now.diff(targetDate, 'hour');

  if (diffInHours < 24) {
    return `${diffInHours}h ago`;
  } else {
    return targetDate.format('MM/DD');
  }
};

export const isWithinHours = (hours: number, timestamp?: number) => {
  if (!timestamp) return false;
  const now = dayjs();
  const targetDate = dayjs(timestamp);
  const diffInHours = now.diff(targetDate, 'hour');
  return diffInHours < hours;
};

// 判断是否是今天
export const isToday = (timestamp: string | number | Date) => {
  const today = dayjs();
  return today.isSame(dayjs(timestamp), 'day');
};

// 判断是否是昨天
export const isYesterday = (timestamp: string | number | Date) => {
  const yesterday = dayjs().subtract(1, 'day');
  return yesterday.isSame(dayjs(timestamp), 'day');
};

// 判断是否本周（不包含今天和昨天）本周从周日开始
export const isThisWeek = (timestamp: string | number | Date) => {
  const now = dayjs();
  const date = dayjs(timestamp);
  const startOfWeek = now.startOf('week');
  const endOfWeek = now.endOf('week');

  return (
    date.isSameOrAfter(startOfWeek) &&
    date.isBefore(endOfWeek) &&
    !isToday(timestamp) &&
    !isYesterday(timestamp)
  );
};

// 判断是否是本月（不包含 today、yesterday、this week）
export const isThisMonth = (timestamp: string | number | Date) => {
  const now = dayjs();
  const date = dayjs(timestamp);
  const startOfMonth = now.startOf('month');
  const endOfMonth = now.endOf('month');

  return (
    date.isSameOrAfter(startOfMonth) &&
    date.isBefore(endOfMonth) &&
    !isToday(timestamp) &&
    !isYesterday(timestamp) &&
    !isThisWeek(timestamp)
  );
};

// 判断是否是本月之前的数据
export const isBefore = (timestamp: string | number | Date) => {
  return dayjs(timestamp).isBefore(dayjs().startOf('month'));
};
